import CalendarLink from 'assets/img/calendarlink.png'
import ClaimLink from 'assets/img/claimlink.png'
import HandbookLink from 'assets/img/handbooklink.png'
import HolidayLink from 'assets/img/holidaylink.png'
import PhonebookLink from 'assets/img/phonebookLink.png'
import VouchersLink from 'assets/img/vouchers.png'
import { GlobalContext } from 'Global'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const ShortCutIcon = styled.div`
  margin: 5px;
  text-align: center;
  font-size: 8pt;
  background-color: ${(props) => props.background || '#fff'};
  color: rgb(255, 255, 255);
  float: left;
  width: 65px;
  height: 80px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`

const Item = ({ color, src, text, to }) => (
  <Link to={to}>
    <ShortCutIcon background={color}>
      <img
        alt="example"
        src={src}
        style={{
          maxHeight: '56px',
          maxWidth: '60px',
        }}
      />
      <p style={{ color: 'white' }}>{text}</p>
    </ShortCutIcon>
  </Link>
)

function QuickLink(props) {
  const { scopes } = React.useContext(GlobalContext)

  return (
    <div className="bg-white rounded-2xl p-1 m-2 flex" style={{ minWidth: '24rem' }}>
      {scopes.includes('employees') && (
        <Item to={'/people/dashboard/#leave'} color={'rgb(235, 116, 49)'} src={HolidayLink} text={'LEAVE'} />
      )}
      {scopes.includes('employees') && (
        <Item to={'/people/dashboard/#claim'} color={'rgb(189,62,147)'} src={ClaimLink} text={'CLAIMS'} />
      )}
      {scopes.includes('invoices') && (
        <Item to={'/clients/invoices'} color={'rgb(122,192,96)'} src={HandbookLink} text={'INVOICES'} />
      )}
      {scopes.includes('employees') && (
        <Item to={'/people/dashboard/'} color={'rgb(38,155,195)'} src={PhonebookLink} text={'OUR TEAM'} />
      )}
      {scopes.includes('general') && (
        <Item to={'/calendar'} color={'rgb(204,195,60)'} src={CalendarLink} text={'EVENTS'} />
      )}
      {scopes.includes('transactions') && (
        <Item to={'/clients/payments/#receipts'} color={'rgb(83,69,151)'} src={HandbookLink} text={'RECEIPTS'} />
      )}
      {scopes.includes('vouchers') && (
        <Item to={'/purchasing/vouchers'} color={'#c5474e'} src={VouchersLink} text={'VOUCHERS'} />
      )}
    </div>
  )
}

export default QuickLink
